"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.SubmenuList = exports.SubmenuItem = exports.SubmenuHeader = exports.SearchWrapper = exports.MenuStyledInput = exports.LogoutSection = exports.LogoText = exports.LogoMark = exports.Logo = exports.ItemWrapper = exports.ItemText = exports.Item = exports.Icon = exports.Highlight = exports.Footer = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Icon = _interopRequireDefault(require("../../Icons/Icon"));
var _InputParts = require("../../Inputs/InputParts");
var _helpers = require("../../helpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* Logo *************************************************************** */
var LogoMark = _styledComponents["default"].div.withConfig({
  displayName: "MenuStyles__LogoMark",
  componentId: "sc-zlcsom-0"
})(["display:block;width:", ";height:", ";flex-shrink:0;"], function (props) {
  return props.theme.menu.logo;
}, function (props) {
  return props.theme.menu.logo;
});
exports.LogoMark = LogoMark;
var LogoText = _styledComponents["default"].div.withConfig({
  displayName: "MenuStyles__LogoText",
  componentId: "sc-zlcsom-1"
})(["height:", ";padding-left:", ";", ""], function (props) {
  return props.height || props.theme.menu.logo;
}, function (props) {
  return props.theme.menu.pH;
}, function (props) {
  return props.height && (0, _styledComponents.css)(["&& svg{height:100%;width:auto;}"]);
});
exports.LogoText = LogoText;
var Logo = _styledComponents["default"].div.withConfig({
  displayName: "MenuStyles__Logo",
  componentId: "sc-zlcsom-2"
})(["display:flex;align-items:", ";cursor:pointer;color:", ";padding-top:", ";padding-bottom:", ";padding-left:calc( ( 2 * ", " + ", " - ", " ) / 2 );margin-top:", ";margin-left:", ";svg{width:100%;height:auto;}"], function (props) {
  return props.alignItems || "center";
}, function (props) {
  return props.theme.colors.menuItem;
}, function (props) {
  return props.theme.menu.pV;
}, function (props) {
  return props.theme.menu.pV;
}, function (props) {
  return props.theme.menu.pH;
}, function (props) {
  return props.theme.menu.iconSize;
}, function (props) {
  return props.theme.menu.logo;
}, function (props) {
  return props.theme.spaces.xs;
}, function (props) {
  return props.theme.menu.mH;
});

/* Items *************************************************************** */
exports.Logo = Logo;
var ItemWrapper = _styledComponents["default"].div.withConfig({
  displayName: "MenuStyles__ItemWrapper",
  componentId: "sc-zlcsom-3"
})(["", ""], function (props) {
  return props.isDisabled && (0, _styledComponents.css)(["cursor:not-allowed;"]);
});
exports.ItemWrapper = ItemWrapper;
var ItemText = _styledComponents["default"].div.withConfig({
  displayName: "MenuStyles__ItemText",
  componentId: "sc-zlcsom-4"
})(["padding-left:", ";line-height:", ";", ""], function (props) {
  return props.theme.menu.pH;
}, function (props) {
  return props.theme.menu.iconSize;
}, function (props) {
  return props.isDisabled && (0, _styledComponents.css)(["opacity:0.5;"]);
});
exports.ItemText = ItemText;
var Icon = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "MenuStyles__Icon",
  componentId: "sc-zlcsom-5"
})(["font-size:", ";"], function (props) {
  return props.theme.menu.iconSize;
});
exports.Icon = Icon;
var menuLinkMixin = (0, _styledComponents.css)(["font-size:", ";text-decoration:none;position:relative;cursor:pointer;white-space:nowrap;"], function (props) {
  return props.theme.menu.fontSize;
});
var itemColorMixin = (0, _styledComponents.css)(["color:", ";&:hover,&.is-active{color:", ";}&.is-active{font-weight:", ";", "{color:", ";}}&.is-disabled{opacity:0.5;", "{opacity:0.5;}}}"], function (props) {
  return (0, _helpers.hex2Rgba)(props.theme.colors.menuItem, 0.8);
}, function (props) {
  return props.theme.colors.menuItem;
}, function (props) {
  return props.theme.fontWeights.semibold;
}, Icon, function (props) {
  return props.theme.colors.menuIconActive;
}, Icon);
var itemColorSearchMixin = (0, _styledComponents.css)([".is-search-value &{color:", ";&:hover,&.is-active{color:", ";}&.is-highlighted{color:", ";}&.is-disabled{opacity:0.7;}}"], function (props) {
  return (0, _helpers.hex2Rgba)(props.theme.colors.menuItem, 0.5);
}, function (props) {
  return (0, _helpers.hex2Rgba)(props.theme.colors.menuItem, 0.5);
}, function (props) {
  return props.theme.colors.menuItem;
});
var Item = _styledComponents["default"].div.withConfig({
  displayName: "MenuStyles__Item",
  componentId: "sc-zlcsom-6"
})(["", ";display:flex;align-items:center;justify-content:flex-start;padding:", " ", ";margin:", " ", ";", " ", ";", ";.is-menu-open &.is-submenu-open,&.is-active{background:", ";border-radius:", ";}.is-menu-open.is-search-value &.is-submenu-open{background:", ";}&.is-disabled{pointer-events:none;}"], menuLinkMixin, function (props) {
  return props.theme.menu.pV;
}, function (props) {
  return props.theme.menu.pH;
}, function (props) {
  return props.theme.menu.mV;
}, function (props) {
  return props.theme.menu.mH;
}, function (props) {
  return props.hasSubmenu && (0, _styledComponents.css)(["flex-direction:column;align-items:flex-start;"]);
}, itemColorMixin, itemColorSearchMixin, function (props) {
  return props.theme.colors.menuBackgroundActive;
}, function (props) {
  return props.theme.borderRadius.m;
}, function (props) {
  return (0, _helpers.hex2Rgba)(props.theme.colors.menuBackgroundActive, 0.5);
});

/* SubMenu  *************************************************************** */
exports.Item = Item;
var SubmenuHeader = _styledComponents["default"].div.withConfig({
  displayName: "MenuStyles__SubmenuHeader",
  componentId: "sc-zlcsom-7"
})(["display:flex;width:100%;", ";.is-search-value &{color:", ";}.is-search-value &:hover{color:", ";}.is-search-value .is-active &{color:", ";}.is-search-value .is-highlighted &{color:", ";&:hover{color:", ";}}", "{flex-shrink:0;&.is-disabled{opacity:0.5;}}", "{flex-grow:1;> *{display:flex;justify-content:space-between;}}"], itemColorMixin, function (props) {
  return (0, _helpers.hex2Rgba)(props.theme.colors.menuItem, 0.5);
}, function (props) {
  return props.theme.colors.menuItem;
}, function (props) {
  return (0, _helpers.hex2Rgba)(props.theme.colors.menuItem, 0.5);
}, function (props) {
  return props.theme.colors.menuItem;
}, function (props) {
  return props.theme.colors.menuItem;
}, Icon, ItemText);
exports.SubmenuHeader = SubmenuHeader;
var SubmenuList = _styledComponents["default"].ul.withConfig({
  displayName: "MenuStyles__SubmenuList",
  componentId: "sc-zlcsom-8"
})(["display:block;display:none;margin:0;.is-menu-open .is-submenu-open &{display:block;}li{margin-top:", ";}"], function (props) {
  return props.theme.menu.pV;
});
exports.SubmenuList = SubmenuList;
var SubmenuItem = _styledComponents["default"].div.withConfig({
  displayName: "MenuStyles__SubmenuItem",
  componentId: "sc-zlcsom-9"
})(["", ";", ";", ";padding-left:calc( ", " + ", " );&.is-active::before{content:\"\";display:block;position:absolute;left:calc((", " - 6px) / 2);top:50%;transform:translateY(-50%);width:6px;height:6px;color:", ";border-radius:50%;background:currentColor;}&.is-disabled{pointer-events:none;&::before{opacity:0.5;}}"], menuLinkMixin, itemColorMixin, itemColorSearchMixin, function (props) {
  return props.theme.menu.iconSize;
}, function (props) {
  return props.theme.menu.pH;
}, function (props) {
  return props.theme.menu.iconSize;
}, function (props) {
  return props.theme.colors.menuIconActive;
});

/* Search *************************************************************** */

// const ItemField = styled
exports.SubmenuItem = SubmenuItem;
var SearchWrapper = _styledComponents["default"].div.withConfig({
  displayName: "MenuStyles__SearchWrapper",
  componentId: "sc-zlcsom-10"
})(["margin:", " ", ";padding:", " ", ";max-height:calc( ", " + ", " * 2 );.is-menu-open &{padding:calc( ", " - ( ", " - ", " ) / 2 ) 0;}", "{cursor:pointer;}button{color:", ";&:hover,&:focus{color:", ";}}"], function (props) {
  return props.theme.spaces.xs;
}, function (props) {
  return props.theme.menu.mH;
}, function (props) {
  return props.theme.menu.pV;
}, function (props) {
  return props.theme.menu.pH;
}, function (props) {
  return props.theme.menu.iconSize;
}, function (props) {
  return props.theme.menu.pV;
}, function (props) {
  return props.theme.menu.pV;
}, function (props) {
  return props.theme.fields.height;
}, function (props) {
  return props.theme.menu.iconSize;
}, Icon, function (props) {
  return props.theme.colors.menuSearchText;
}, function (props) {
  return props.theme.colors.menuSearchText;
});
exports.SearchWrapper = SearchWrapper;
var MenuStyledInput = (0, _styledComponents["default"])(_InputParts.StyledInput).withConfig({
  displayName: "MenuStyles__MenuStyledInput",
  componentId: "sc-zlcsom-11"
})(["background:", ";color:", ";border:transparent;&:focus{background:none;border:1px solid ", ";}&::placeholder{color:", ";opacity:0.5;}"], function (props) {
  return props.theme.colors.menuSearchBackground;
}, function (props) {
  return props.theme.colors.menuSearchText;
}, function (props) {
  return props.theme.colors.menuSearchText;
}, function (props) {
  return props.theme.colors.menuSearchText;
});
exports.MenuStyledInput = MenuStyledInput;
var Highlight = _styledComponents["default"].strong.withConfig({
  displayName: "MenuStyles__Highlight",
  componentId: "sc-zlcsom-12"
})(["background-color:", ";border-radius:", ";padding:0 1px;"], function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.borderRadius.s;
});

/* Logout  *************************************************************** */
exports.Highlight = Highlight;
var LogoutSection = _styledComponents["default"].div.withConfig({
  displayName: "MenuStyles__LogoutSection",
  componentId: "sc-zlcsom-13"
})(["position:relative;padding-top:calc(1.5 * ", ");"], function (props) {
  return props.theme.menu.pV;
});

/* Footer  *************************************************************** */
exports.LogoutSection = LogoutSection;
var Footer = _styledComponents["default"].div.withConfig({
  displayName: "MenuStyles__Footer",
  componentId: "sc-zlcsom-14"
})(["flex-grow:1;cursor:pointer;display:flex;align-items:flex-end;&:hover ", "{color:", ";}"], Icon, function (props) {
  return props.theme.colors.menuItemActive;
});
exports.Footer = Footer;
var Wrapper = _styledComponents["default"].nav.withConfig({
  displayName: "MenuStyles__Wrapper",
  componentId: "sc-zlcsom-15"
})(["height:100%;display:flex;flex-direction:column;justify-content:flex-start;overflow-x:hidden;width:", ";transition:width 0.5s ease-in-out;border-right:1px solid ", ";", ";"], function (props) {
  return props.theme.menu.openWidth || "182px";
}, function (props) {
  return props.theme.colors.border;
}, function (props) {
  return !props.isOpen && (0, _styledComponents.css)(["width:calc( 2 * (", " + ", ") + ", " );transition:width 0.2s ease-out;", ",", "{opacity:0;margin-left:0;}"], props.theme.menu.pH, props.theme.menu.mH, props.theme.menu.iconSize, ItemText, LogoText);
});
exports.Wrapper = Wrapper;